export default (eventName, props = {}) => {
  if (typeof window === "undefined") return;

  const server = props.server || (window.s && window.s.server);
  const commonProps = {
    channel: "student verification",
    pageName: `${server}|student verification|${props.pageName}`,
    prop31: props.loginStatus,
    eVar10: props.customerId,
  };

  if (!props.status) {
    props.status = "500";
    props.breadcrumb = "student-validation";
    props.errorMessage = "Request failed with status code 500";
  }

  const config = {
    "student-verification-page-load": {
      linkVars: {
        prop8: "student verification",
        eVar15: "student verification",
        eVar60: props.pageName,
        eVar61: props.pageName,
        ...commonProps,
        ...props?.extraProps,
      },
      eventVars: {
        ...props?.extraProps?.eventVars,
      },
    },
  };

  return config[eventName];
};
